module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "equipamentoDialog"
  }, [_c('md-dialog', {
    ref: "eq_dialog",
    attrs: {
      "md-open-from": "#addEquipamento",
      "md-close-to": "#addEquipamento"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "display": "contents"
    }
  }, [_c('md-dialog-content', [_c('md-layout', {
    attrs: {
      "md-align": "center",
      "md-column": "",
      "md-gutter": ""
    }
  }, [_c('span', {
    staticClass: "md-headline"
  }, [_vm._v("SALVANDO")]), _vm._v(" "), _c('md-spinner', {
    attrs: {
      "md-size": 50,
      "md-stroke": 1,
      "md-indeterminate": ""
    }
  })], 1)], 1)], 1) : _c('div', {
    staticStyle: {
      "display": "contents"
    }
  }, [_c('md-dialog-title', [_vm._v("Equipamento")]), _vm._v(" "), _c('md-dialog-content', [_c('md-input-container', [_c('label', [_vm._v("Tipo do item")]), _vm._v(" "), _c('md-select', {
    model: {
      value: (_vm.structure),
      callback: function($$v) {
        _vm.structure = $$v
      },
      expression: "structure"
    }
  }, _vm._l((_vm.equipmentList), function(eq, index) {
    return _c('md-option', {
      key: eq.name,
      attrs: {
        "value": index
      }
    }, [_vm._v(_vm._s(eq.name))])
  }), 1)], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Informações adicionais")]), _vm._v(" "), _c('md-textarea', {
    attrs: {
      "maxlength": "120"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Marca")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: (_vm.brand),
      callback: function($$v) {
        _vm.brand = $$v
      },
      expression: "brand"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Modelo")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Patrimônio")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "maxlength": "120"
    },
    model: {
      value: (_vm.patrimony),
      callback: function($$v) {
        _vm.patrimony = $$v
      },
      expression: "patrimony"
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentItemKey != null),
      expression: "currentItemKey != null"
    }],
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.removeItem()
      }
    }
  }, [_vm._v("Excluir")]), _vm._v(" "), _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentItemKey != null),
      expression: "currentItemKey != null"
    }],
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.saveItem()
      }
    }
  }, [_vm._v("Alterar")]), _vm._v(" "), _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentItemKey == null),
      expression: "currentItemKey == null"
    }],
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("Adicionar")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7988e1f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddStructureDialog.vue
// module id = 835
// module chunks = 1